import React, { useContext, useCallback } from "react";
import ReactDOM from "react-dom";
import { Icons } from "../../../Icon";
import { IColumnRenderProps } from "../Column";
import { lang } from "@/components/Joyspace/context";
import { Button, Dropdown, Popover, Tooltip } from "antd";

// import { AuthData } from '@/types/LocalConfig';
// import { GlobalContextConfig } from '@/context/GlobalContext';
import styles from "./index.module.less";
import { SyncStatusEunm } from "@/components/Joyspace/controllers/JoyspaceController";
import IconFont from "@/components/icon";
import { analysisLog } from "@/utils/logAnalytics";
import { getPageMenuLogId } from "@/components/Joyspace/contextMenus/utils";
import { ContextMenuMode, FileType } from "@/components/Joyspace/types";
import { useNavigator } from "@/utils/NetworkCheck";
import GlobalContext from "@/context/GlobalContext";
import events from "@/components/Joyspace/context/events";

export interface IProps<T> {
  callbackProps: IColumnRenderProps<T>;
  render: IContextRender<T>;
}

export type ContextCallbackProps<T> = IColumnRenderProps<T>;

export type IContextRender<T> = (option: Option, callbackProps: IColumnRenderProps<T>) => void;

export type Option = (props: {
  children: React.ReactElement | string;
  callbackOrModal?: (() => any) | React.ReactElement;
  type?: string;
  isAllow?: boolean;
  splitCode?: number;
  icon?: string;
  tip?: string;
  from?: string;
  allowTips?: string;
}) => void;

export default function <T>(props: IProps<T>) {
  const { data, contextMenuMode } = props.callbackProps;
  const [status, setStatus] = React.useState(false);
  const [visible, setVisible] = React.useState(false);
  const dropdown = React.useRef<HTMLDivElement>(null);
  const [disabled, setDisabled] = React.useState(false);
  const { onLine } = useContext(GlobalContext);
  // console.log(props, 'statusstatusstatusstatusstatus', data);
  React.useEffect(() => {
    const destroy = () => document.removeEventListener("mouseenter", close, false);
    const close = () => {
      destroy();
      setStatus(false);
    };
    document.addEventListener("mouseleave", close, false);
    return destroy;
  }, []);

  React.useEffect(() => {
    const menu = dropdown.current;
    if (menu) {
      const top = getElementTop(menu);
      const height = menu.offsetHeight;
      if (top + height > getClientHeight()) {
        menu.style.top = -height + "px";
      }
    }
  }, [status]);
  const handleVisibleChange = useCallback((visible = false) => {
    // if (disabled) {
    //     return;
    // }
    if (visible) {
      events.emit("list.check");
    }
    setVisible(visible);
  }, []);
  React.useEffect(() => {
    events.on("handlePopoverVisibleChange", handleVisibleChange);
    return () => {
      events.off("handlePopoverVisibleChange", handleVisibleChange);
    };
  }, [handleVisibleChange]);

  // 操作菜单上报
  const handleMenuClick = (from: string, opType: string) => {
    if (opType === "collaborate") {
      return;
    }
    const eventId = getPageMenuLogId(opType, data);
    // @ts-ignore
    const { id, type, page_type } = data;
    const rType = page_type || type;
    let rFrom = from;
    if (!rFrom) {
      const path = document.location.pathname;
      if (path.indexOf("collections")) {
        rFrom = "collections";
      }
      if (path.indexOf("teamspace")) {
        rFrom = "TEAM_SPACE";
      }
      if (path.indexOf("trashes")) {
        rFrom = "trashes";
      }
      if (path.indexOf("myspace")) {
        rFrom = "MY_SPACE";
      }
    }
    analysisLog("xtbg_jzb_joyspace_home_1676548210761", eventId, rFrom, id, type || page_type);
  };

  const create = () => {
    const { callbackProps, render } = props;
    const items: React.ReactElement[] = [];
    let storeSplitCode = 1;
    const option: Option = ({
      children: name,
      callbackOrModal,
      isAllow = true,
      type,
      icon,
      splitCode,
      tip,
      from,
      allowTips
    }) => {
      // let _disabled = false;
      // // 在断网时，只有离线新建的文档才删除按钮功能，其他所有的按钮操作都要禁止。
      // if (disabled) {
      //     if ((data as any).isNew) {
      //         _disabled = type !== 'delete';
      //     } else {
      //         _disabled = true;
      //     }
      //     if (type === 'edit') {
      //         _disabled = false;
      //     }
      // } else {
      //     // 在有网时，离线新建的文档更多操作禁止
      //     if ((data as any).isNew) {
      //         _disabled = true;
      //     }
      // }
      if (splitCode && storeSplitCode < splitCode) {
        storeSplitCode = splitCode;
        items.push(<div className={styles["joyspace-operate-split-line"]} />);
      }
      items.push(
        <MenuItem
          setVisible={setVisible}
          disabled={!isAllow || ((data as any).status === 0 && name !== lang("common.list-remove"))}
          icon={icon}
          name={name}
          tip={tip}
          allowTips={allowTips}
          callbackOrModal={callbackOrModal}
          handleMenuClick={() => {
            return handleMenuClick(from as string, type as string);
          }}
          key={type}
          type={type ?? ""}
          status={(data as any).status}
          isPage={!!(data as any).page_type}
        />
      );
    };
    // console.log(items, 'itemsitemsitemsitems==>');
    render(option, callbackProps);
    return items;
  };

  const content = (
    <ul
      className={styles["joyspace-operate-lists"]}
      onContextMenu={(e) => {
        e.stopPropagation();
      }}
    >
      {create()}
    </ul>
  );
  React.useMemo(() => {
    setDisabled(onLine);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLine]);
  if (contextMenuMode === ContextMenuMode.ContextMenu) {
    return <div className={styles["joyspace-context-menu"]}>{content}</div>;
  }
  return (
    <Popover
      trigger={["click"]}
      onVisibleChange={handleVisibleChange}
      visible={visible}
      content={content}
      overlayClassName={styles["joyspace-menu-popover"]}
      // align={{
      //     offset: [-30, 0],
      // }}
      placement="bottomRight"
    >
      <span
        onClick={(e: any) => {
          e.stopPropagation();
          events.emit("hideContextMenus");
          handleVisibleChange(!visible);
        }}
        onContextMenu={(event) => {
          event.stopPropagation();
        }}
        className={`${styles["joyspace-trigger-icon"]} ${
          visible ? styles["joyspace-trigger-actions"] : ""
        } `}
      >
        {Icons.trigger}
      </span>
    </Popover>
  );
}

function MenuItem(props: {
  disabled: boolean;
  callbackOrModal: (() => any) | React.ReactElement | undefined;
  name: string | React.ReactElement;
  icon?: string;
  tip?: string;
  setVisible: ((v: boolean) => any) | React.ReactElement | undefined;
  handleMenuClick: () => any;
  allowTips?: string;
  status: any;
  isPage: any;
  type: string;
}) {
  const {
    callbackOrModal,
    setVisible,
    disabled,
    icon,
    tip,
    allowTips = "",
    status,
    isPage,
    handleMenuClick
  } = props;
  let menuStyles =
    allowTips && disabled
      ? {
          display: "flex",
          alignItems: "center",
          cursor: "not-allowed",
          justifyContent: "space-between"
        }
      : {};
  let _disabled = allowTips && disabled && useNavigator.onLine;
  let isAllowTips = isPage ? _disabled && status : _disabled;
  // console.log(
  //     isAllowTips,
  //     allowTips,
  //     status,
  //     'isAllowTipsisAllowTipsisAllowTipsisAllowTips',
  //     tip,
  //     disabled
  // );
  return (
    <li
      key={"menu:" + props.type}
      style={menuStyles}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (disabled) return;
        events.emit("hideContextMenus");
        handleMenuClick();
        if (typeof callbackOrModal === "function" && typeof setVisible === "function") {
          setVisible(false);
          callbackOrModal();
        } else if (React.isValidElement(callbackOrModal)) {
          ReactDOM.render(callbackOrModal, document.createDocumentFragment());
        }
      }}
    >
      {isAllowTips ? (
        <Tooltip placement="left" title={allowTips} className={styles["joyspace-operate-allow"]}>
          <Button type="text" disabled={true}>
            {icon && <IconFont type={`icon${icon}`} className={styles["joyspace-operate-icon"]} />}
            {props.name}
          </Button>
        </Tooltip>
      ) : (
        <Button type="text" disabled={disabled}>
          {icon && <IconFont type={`icon${icon}`} className={styles["joyspace-operate-icon"]} />}
          {props.name}
        </Button>
      )}
      {tip &&
        (disabled ? (
          <IconFont
            type="iconquanjutishi"
            className={
              disabled
                ? `${styles["joyspace-operate-icon-disabled"]} ${styles["tip"]} ${styles["joyspace-operate-tip"]} `
                : styles["tip"]
            }
          />
        ) : (
          <Tooltip placement="top" title={tip} className={styles["joyspace-operate-tip"]}>
            <IconFont type="iconquanjutishi" className={styles["tip"]} />
          </Tooltip>
        ))}
    </li>
  );
}

function getClientHeight() {
  return document.documentElement.clientHeight ?? document.body.clientHeight;
}

function getElementTop(element: HTMLElement) {
  let parent: HTMLElement = element;
  let total = 0;
  do {
    total += parent.offsetTop;
    parent = parent.offsetParent as HTMLElement;
  } while (parent);
  return total;
}
